import './Header.scss'
import '../../style/main.scss'
import gdcLogo from "../../img/gdcLogo.svg"
import Logo from "../../img/Logo.svg"
import Union from '../../img/Union.svg'


export default function Header() {

    return(
            
        <div className="header">

            <img src={Union} alt="icon" className="header__container--icon" />

            <div className="conatiner header__container">
                <a href="/">
                    <img src={Logo} alt="logo" className="header__container--image" width="170"/>
                </a>

                <div className="sub header__container--sub">
                    <p className="sub--text">Part of</p>
                    <img src={gdcLogo} alt="gdcLogo" className="sub--image"/>
                </div>
            </div>
        </div>
        
    )
}